import { render } from "./Video.vue?vue&type=template&id=2f1cd1db"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
script.render = render

export default script